<template>
	<el-skeleton animated :rows="3" :loading="loading" :key="loading">
		<template slot="template">
			<div class="asin-info-item-div">
				<el-skeleton-item variant="image" style="width: 70px; height: 70px;"/>
				<div class="asin-info-div-text-div">
					<el-skeleton-item variant="p" style="width: 50%"/>
					<el-skeleton-item variant="p"/>
					<el-skeleton-item variant="p" style="width: 70%;"/>
				</div>
			</div>
		</template>
		<template>
			<div>
				<div class="asin-info-item-div" v-if="!loading">
					<div class="asin-info-div-img-div">
						<el-image style="width: 100%; height: 100%" :fit="'contain'"
							:src="asinInfo.images && asinInfo.images.length > 0 ? asinInfo.images[0] : ''"></el-image>
					</div>
					<div class="asin-info-div-text-div">
						<div class="overflow-one-line" style="font-size: 15px">
							<span v-if="asinInfo.title">
								{{ asinInfo.title }}
							</span>
							<span class="no-data-font" v-else> -- </span>
						</div>
						<div class="overflow-one-line">
							<span class="text-span" v-if="asinInfo.price">
								价格 :
								<span>{{ asinInfo.price }}</span>
							</span>
							<span class="text-span" v-if="asinInfo.seller">
								卖家 :
								<span>{{ asinInfo.seller }}</span>
							</span>
							<span class="text-span" v-if="asinInfo.brand">
								品牌 :
								<span>{{ asinInfo.brand }}</span>
							</span>
							<span class="text-span" v-if="asinInfo.distributionMode">
								配送方式 :
								<span>{{ asinInfo.distributionMode }}</span>
							</span>
							<span class="text-span" v-if="asinInfo.variants">
								变体数量 :
								<span>{{ asinInfo.variants.length }}</span>
							</span>
						</div>
						<div class="overflow-one-line">
							<span style="margin-right: 10px">
								<asin-badge-sub :asinInfo="asinInfo"></asin-badge-sub>
							</span>
							<span class="text-span">
								{{ asinInfo.asin }}
								<copy-sub :value="asinInfo.asin"></copy-sub>
								<a :href="'https://www.amazon.com/dp/' + asinInfo.asin" target="_blank"
									class="el-icon-paperclip"></a>
							</span>
						</div>
					</div>
				</div>
			</div>
		</template>
	</el-skeleton>
</template>

<script>
import ASIN_BADGE_SUB from "@/components/template/view/keyword/monitoring/asinInfo/sub/badgeSub";
import COPY_SUB from "@/components/template/otherSub/copySub";

export default {
	name: "asinInfoSub",
	components: {
		'asin-badge-sub': ASIN_BADGE_SUB,
		'copy-sub': COPY_SUB
	},
	props: {
		asinInfo: {
			required: true
		},
		loading : {
			types : Boolean,
			default : true
		}
	}
}
</script>

<style scoped>
.asin-info-item-div{
	display: flex;
	border-bottom: 1px solid #EBEEF5;
	padding: 15px 0;
}
.asin-info-div-img-div{
	height: 65px;
	width: 65px;
	padding: 5px;
	border: 1px solid #E4E7ED;
	border-radius: 4px;
}
.asin-info-div-text-div{
	flex: 1;
	width: 0;
	min-width: 0;
	margin-left: 20px;
	line-height: 27px;
}
.asin-info-div-text-div .text-span{
	margin-right: 20px;
	color: #909399;
}
</style>